import { connect } from 'react-redux';
import TeamProfileComponent from './TeamProfileComponent';
import { teamProfileOperations } from './duck';

const mapStateToProps = ({ locationReducer, appReducer, teamProfileReducer}) => {
  return {
    locationId: locationReducer.location_code,
    userPrivilege: teamProfileReducer,
    locationSettings: appReducer.location.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  function getUserProfileDispatch(locationId, userId) {
    // dispatch
    dispatch(teamProfileOperations.resetUserProfileOperation());
    dispatch(teamProfileOperations.getUserProfileOperation(locationId, userId));
  }

  return { getUserProfileDispatch };
};

const TeamProfileContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamProfileComponent);

export default TeamProfileContainer;
